import { Routes } from '@angular/router';

import { MainComponent } from './components/main/main.component';
import { unsavedChangesGuard } from './utilities/guards/unsaved-changes.guard';
import { roleRestrictionGuard } from './utilities/guards/role-restriction.guard';
import { Permission } from './utilities/models/user';
import { authGuard } from './utilities/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '',
    component: MainComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then((c) => c.DashboardComponent)
      },
      {
        path: 'news',
        loadComponent: () => import('./components/news/news.component').then((c) => c.NewsComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.newsRead],
        }
      },
      {
        path: 'news/:newsId',
        loadComponent: () => import('./components/news/news-article/news-article.component').then((c) => c.NewsArticleComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.newsRead],
        }
      },
      {
        path: 'managers',
        loadComponent: () => import('./components/managers/managers.component').then((c) => c.ManagersComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.managerRead, Permission.managerWrite],
        }
      },
      {
        path: 'members',
        loadComponent: () => import('./components/members/members.component').then((c) => c.MembersComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.memberRead, Permission.memberWrite],
        },
      },
      {
        path: 'news-editor',
        loadComponent: () => import('./components/news/news-editor/news-editor.component').then((c) => c.NewsEditorComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.newsWrite],
        },
      },
      {
        path: 'request-management',
        loadComponent: () => import('./components/requests/request-management/request-management.component').then((c) => c.RequestManagementComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.requestAcceptance],
        },
      },
      {
        path: 'my-requests',
        loadComponent: () => import('./components/requests/my-requests/my-requests.component').then((c) => c.MyRequestsComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.requestRead, Permission.requestWrite],
        },
      },
      {
        path: 'my-relatives',
        loadComponent: () => import('./components/relatives/my-relatives/my-relatives.component').then((c) => c.MyRelativesComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.relativeRead, Permission.relativeWrite],
        },
      },
      {
        path: 'relative-requests',
        loadComponent: () => import('./components/relatives/relative-requests/relative-requests.component').then((c) => c.RelativeRequestsComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.relativeAcceptance],
        },
      },
      {
        path: 'audits',
        loadComponent: () => import('./components/audits/audits.component').then((c) => c.AuditsComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.auditRead],
        },
      },
      {
        path: 'procedures',
        loadComponent: () => import('./components/procedures/procedures.component').then((c) => c.ProceduresComponent),
        canActivate: [roleRestrictionGuard],
        canDeactivate: [unsavedChangesGuard],
        data: {
          roleRestriction: [Permission.proceduresRead, Permission.proceduresWrite],
        },
      },
      {
        path: 'export',
        loadComponent: () => import('./components/export/export.component').then((c) => c.ExportComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: [Permission.exportRead, Permission.exportExecutor],
        },
      }
    ],
  },
  {
    path: 'registration',
    loadComponent: () => import('./components/registration/registration.component').then((c) => c.RegistrationComponent)
  }
];
